export const cardDetails = {
    CREDIT: {
        MAIN: {
            fields: [
                ['owner', 'directDebitAccount', 'characteristic'],
                [
                    'limit',
                    'outstandingAmount',
                    'balance',
                    'minimalMonthlyAmount',
                    'minimumPaymentRateAmount',
                    'expiryDate',
                    'limitExpiryDate',
                ],
            ],
        },
        AUTHORIZED: {
            fields: [
                ['owner', 'directDebitAccount', 'characteristic'],
                [
                    'limit',
                    'outstandingAmount',
                    'balance',
                    'minimalMonthlyAmount',
                    'minimumPaymentRateAmount',
                    'expiryDate',
                    'limitExpiryDate',
                ],
            ],
        },
        AUTHORIZED_STANDALONE: {
            fields: [
                ['owner', 'directDebitAccount', 'characteristic'],
                [
                    'limit',
                    'outstandingAmount',
                    'balance',
                    'minimalMonthlyAmount',
                    'minimumPaymentRateAmount',
                    'expiryDate',
                    'limitExpiryDate',
                ],
            ],
        },
    },
};
